import type { SimpleFieldConfig } from "@/components/shared/UniversalCRMTable/types";
import { defineFieldConfigMap } from "@/components/shared/UniversalCRMTable/types/field-config-types";
import { MapPin } from "lucide-react";

// Location fields: address, city, state, zip_code, country
// None of these appear in current saved views' visibleColumns.
export const locationContactFields = defineFieldConfigMap({
  // FIELD: address
  address: {
    type: "textarea",
    label: "Address",
    sortable: false,
    filterable: false,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 3,
    width: 200,
    minWidth: 150,
    maxWidth: 300,
    placeholder: "Enter full address",
    icon: "MapPin",
    // Role-based access control - visible to all roles
    allowedRoles: ["client_user", "wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "location",
    graphqlSelector: "address",
  },
  // FIELD: city
  city: {
    type: "text",
    label: "City",
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 1,
    filterType: "contains",
    width: 120,
    minWidth: 100,
    maxWidth: 150,
    placeholder: "Enter city",
    icon: "MapPin",
    // Role-based access control - visible to all roles
    allowedRoles: ["client_user", "wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "location",
    graphqlSelector: "city",
  },
  // FIELD: state
  state: {
    type: "text",
    label: "State",
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 1,
    filterType: "contains",
    width: 100,
    minWidth: 80,
    maxWidth: 120,
    placeholder: "Enter state",
    icon: "MapPin",
    // Role-based access control - visible to all roles
    allowedRoles: ["client_user", "wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "location",
    graphqlSelector: "state",
  },
  // FIELD: zip_code
  zip_code: {
    type: "text",
    label: "Zip Code",
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 1,
    filterType: "contains",
    width: 100,
    minWidth: 80,
    maxWidth: 120,
    placeholder: "Enter zip code",
    icon: "MapPin",
    // Role-based access control - visible to all roles
    allowedRoles: ["client_user", "wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "location",
    graphqlSelector: "zip_code",
  },
  // FIELD: country
  country: {
    type: "text",
    label: "Country",
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 1,
    filterType: "contains",
    width: 120,
    minWidth: 100,
    maxWidth: 150,
    placeholder: "Enter country",
    icon: "MapPin",
    // Role-based access control - visible to all roles
    allowedRoles: ["client_user", "wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "location",
    graphqlSelector: "country",
  },
});
